import { createElement, lazy } from 'react';
import type { RouteObject } from 'react-router';

import { ProtectedRoute } from '@/features/auth/components/ProtectedRoute';

const SitesPage = lazy(() =>
  import('./pages/SitesPage').then((module) => ({ default: module.SitesPage })),
);
const SiteDetailPage = lazy(() =>
  import('./pages/SiteDetailPage').then((module) => ({ default: module.SiteDetailPage })),
);
const DepartmentsPage = lazy(() =>
  import('./pages/departments/DepartmentsPage').then((module) => ({
    default: module.DepartmentsPage,
  })),
);
const DepartmentDetailPage = lazy(() =>
  import('./pages/departments/DepartmentsDetailPage').then((module) => ({
    default: module.DepartmentDetailPage,
  })),
);
const PositionsPage = lazy(() =>
  import('./pages/PositionsPage').then((module) => ({ default: module.PositionsPage })),
);
const PositionDetailPage = lazy(() =>
  import('./pages/PositionDetailPage').then((module) => ({ default: module.PositionDetailPage })),
);
const QuickPicksPage = lazy(() =>
  import('./pages/QuickPicksPage').then((module) => ({ default: module.QuickPicksPage })),
);
const ManualDetailPage = lazy(() =>
  import('./pages/manuals/ManualDetailPage').then((module) => ({
    default: module.ManualDetailPage,
  })),
);
const VersionDetailPage = lazy(() =>
  import('./pages/manuals/VersionDetailPage').then((module) => ({
    default: module.VersionDetailPage,
  })),
);
const ThemesPage = lazy(() =>
  import('./pages/manuals/ThemesPage').then((module) => ({
    default: module.ThemesPage,
  })),
);
const ThemesDetailPage = lazy(() =>
  import('./pages/manuals/ThemeDetailPage').then((module) => ({
    default: module.ThemesDetailPage,
  })),
);
const VersionReviewPage = lazy(() =>
  import('./pages/manuals/VersionReviewPage').then((module) => ({
    default: module.VersionReviewPage,
  })),
);
export const organizationRoutes: RouteObject[] = [
  {
    path: 'organizacion',
    children: [
      {
        element: createElement(ProtectedRoute, { view: 'sites' }),
        children: [
          { path: 'sedes/:id', element: createElement(SiteDetailPage) },
          { path: 'sedes', element: createElement(SitesPage) },
        ],
      },
      {
        element: createElement(ProtectedRoute, { view: 'departments' }),
        children: [
          { path: 'areas/:id', element: createElement(DepartmentDetailPage) },
          { path: 'areas', element: createElement(DepartmentsPage) },
        ],
      },
      {
        element: createElement(ProtectedRoute, { view: 'positions' }),
        children: [
          { path: 'cargos/:id', element: createElement(PositionDetailPage) },
          { path: 'cargos', element: createElement(PositionsPage) },
        ],
      },
      {
        element: createElement(ProtectedRoute, { view: 'quickPicks' }),
        children: [{ path: 'sugerencias-rapidas', element: createElement(QuickPicksPage) }],
      },
      {
        element: createElement(ProtectedRoute, { view: 'manualDetail' }),
        children: [{ path: 'manuales/:id', element: createElement(ManualDetailPage) }],
      },
      {
        element: createElement(ProtectedRoute, { view: 'themes' }),
        children: [
          { path: 'versiones/:id', element: createElement(VersionDetailPage) },
          { path: 'temas/:id', element: createElement(ThemesDetailPage) },
          { path: 'temas', element: createElement(ThemesPage) },
          { path: 'revisar-versiones', element: createElement(VersionReviewPage) },
        ],
      },
    ],
  },
];
